// export default {
//   apiKey: "AIzaSyDc9xlRFBbYdyZuZrzmz8l49xLs0PaJWIs",
//   authDomain: "moodboard-maker.firebaseapp.com",
//   databaseURL: "https://moodboard-maker.firebaseio.com",
//   projectId: "moodboard-maker",
//   storageBucket: "moodboard-maker.appspot.com",
//   messagingSenderId: "615096046173",
//   appId: "1:615096046173:web:d6d553de23dcdec87c33b4",
//   measurementId: "G-KC1F1SBWTS",
// };
const firebaseConfig = {
  apiKey: "AIzaSyD262MrkdeHH-nmkugfjk75j9oCEk66UK0",
  authDomain: "moodboard-maker-b0f95.firebaseapp.com",
  databaseURL: "https://moodboard-maker-b0f95-default-rtdb.firebaseio.com",
  projectId: "moodboard-maker-b0f95",
  storageBucket: "moodboard-maker-b0f95.firebasestorage.app",
  messagingSenderId: "157939962000",
  appId: "1:157939962000:web:e772e86e77e6ff95fc8815",
  measurementId: "G-7RTMJE309M",
};

export default firebaseConfig;
